import { CreateRequestState } from "pages/new/context/initialState";
import { CreateQuoteFormState } from "./schemaValidation";

export const getCreateQuoteFormDefaultValues = (
  bookingContact: CreateRequestState["bookingContact"],
  trip: CreateRequestState["trip"]
): CreateQuoteFormState => {
  const route = trip.routes[0];

  return {
    bookingContact: {
      firstName: bookingContact.firstName || "",
      lastName: bookingContact.lastName || "",
      email: bookingContact.email || "",

      // store phoneFields as object instead of flattended into booking contact
      // so that they can be passed into RHF international phone number format component
      phoneFields: {
        mobilePhone: bookingContact.mobilePhone || "",
        phoneCountryCode: bookingContact.phoneCountryCode || "",
        phoneCountryDialCode: bookingContact.phoneCountryDialCode || "",
        phoneCountryFormat: bookingContact.phoneCountryFormat || "",
        phoneCountryName: bookingContact.phoneCountryName || "",
      },
    },
    route: {
      carryOnLuggage: route?.carryOnLuggage || 0,
      checkedLuggage: route?.checkedLuggage || 0,
      oversizeLuggage: route?.oversizeLuggage || 0,
    },
  };
};
